import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const PageTitlesContext = createContext({ titles: {}, refresh: () => {} });

export function PageTitlesProvider({ children }) {
  const [titles, setTitles] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/page-titles");
      setTitles(data);
    } catch {
      /* fall back to defaults handled by consumers */
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PageTitlesContext.Provider value={{ titles, refresh }}>
      {children}
    </PageTitlesContext.Provider>
  );
}

/**
 * Returns bilingual title/subtitle for a given page key.
 * key: one of home | about | events | products | angelina | crystals | booking | dashboard
 * fallback: { title_zh, title_en, subtitle_zh, subtitle_en } used until context resolves.
 */
export function usePageTitle(key, fallback = {}) {
  const { titles } = useContext(PageTitlesContext);
  const entry = titles[key] || {};
  return {
    title_zh: entry.title_zh || fallback.title_zh || "",
    title_en: entry.title_en || fallback.title_en || "",
    subtitle_zh: entry.subtitle_zh || fallback.subtitle_zh || "",
    subtitle_en: entry.subtitle_en || fallback.subtitle_en || "",
  };
}

export function usePageTitles() {
  return useContext(PageTitlesContext);
}
